import { createContext } from '@chakra-ui/react-utils';
import { Interpreter } from 'xstate';

type AnyInterpreter = Interpreter<any, any, any>;

export const [WizardProvider, useWizardContext] = createContext<AnyInterpreter>(
  { name: 'WizardContext' },
);
